import { render } from "./DownloadsAuditingDocuments.vue?vue&type=template&id=3c83b517"
import script from "./DownloadsAuditingDocuments.vue?vue&type=script&lang=js"
export * from "./DownloadsAuditingDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__